<mat-form-field appearance="outline">
  <mat-label>{{label}}</mat-label>
  <textarea matInput placeholder={{placeholder}} [formControl]="$any(ngControl?.control)"></textarea>
</mat-form-field>